module.exports = __webpack_public_path__ + "static/img/2.00fe52a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/car/2.png
// module id = 3oYi
// module chunks = 37